import { render, staticRenderFns } from "./turnstile.vue?vue&type=template&id=13331422&"
import script from "./turnstile.vue?vue&type=script&lang=js&"
export * from "./turnstile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13331422')) {
      api.createRecord('13331422', component.options)
    } else {
      api.reload('13331422', component.options)
    }
    module.hot.accept("./turnstile.vue?vue&type=template&id=13331422&", function () {
      api.rerender('13331422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/turnstile.vue"
export default component.exports